"use client";

import dynamic from "next/dynamic";

const FreeTemplatesSignupForm = dynamic(
  () => import("./FreeTemplatesSignupForm"),
  {
    ssr: false,
    loading: () => (
      <div className="space-y-2">
        <div className="flex w-full flex-col gap-3 sm:flex-row">
          <div className="min-w-0 w-full flex-1">
            <input
              id="free-templates-email-placeholder"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="Enter your email"
              disabled
              aria-label="Enter your email"
              className="h-12 w-full rounded-lg border border-slate-500 bg-slate-900 px-4 py-3 text-white placeholder:text-slate-400 disabled:opacity-75"
            />
          </div>
          <button
            type="button"
            disabled
            className="flex h-12 w-full shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[#7f56d9] px-6 py-3 text-sm font-medium text-white disabled:opacity-75 sm:w-auto"
          >
            Send Me the Templates
          </button>
        </div>
        <p className="font-inter font-normal text-slate-300 text-sm leading-5">
          No credit card required. Unsubscribe anytime.
        </p>
      </div>
    ),
  },
);

type FreeTemplatesSignupSlotProps = {
  buttonText: string;
  disclaimerText: string;
};

export default function FreeTemplatesSignupSlot(props: FreeTemplatesSignupSlotProps) {
  return <FreeTemplatesSignupForm {...props} />;
}
